/**
 * ERC Similar Power Validator Adapter for DRC System
 *
 * This validator checks for power net names that differ only in case.
 *
 * Feature-gated via DrcEnabledCheckers.ErcSimilarPowerValidator
 */
import { EditorModes, ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
import { ElectricalPinType, fluxPinTypeToElectricalType } from "../pinTypes";
/**
 * Validator that checks for similar power net names.
 */
export class ErcSimilarPowerValidator {
    reviewType = ReviewType.DesignRuleCheckErcSimilarPower;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems(inputs) {
        const foundProblems = [];
        // Collect power net names
        const powerNets = {};
        for (const [elementUid, element] of Object.entries(inputs.elements)) {
            const terminals = element.part_version_data_cache?.terminals;
            if (!terminals)
                continue;
            for (const terminal of Object.values(terminals)) {
                const pinType = fluxPinTypeToElectricalType(terminal.type);
                if (pinType === ElectricalPinType.POWER_IN || pinType === ElectricalPinType.POWER_OUT) {
                    const netName = terminal.name ?? "";
                    if (!netName)
                        continue;
                    const lowerName = netName.toLowerCase();
                    if (!powerNets[lowerName]) {
                        powerNets[lowerName] = { names: new Set(), elementUids: [] };
                    }
                    powerNets[lowerName].names.add(netName);
                    if (!powerNets[lowerName].elementUids.includes(elementUid)) {
                        powerNets[lowerName].elementUids.push(elementUid);
                    }
                }
            }
        }
        // Report power nets with case differences
        for (const [lowerName, data] of Object.entries(powerNets)) {
            if (data.names.size > 1) {
                const nameList = Array.from(data.names).join(", ");
                foundProblems.push({
                    problemTypeKey: this.problemTypeKey,
                    key: `${this.problemTypeKey}_${lowerName}`,
                    label: `Similar power net names: ${nameList}`,
                    affectedItems: data.elementUids.map((uid) => ({ type: "element", uid })),
                    affectedViews: [EditorModes.schematic],
                });
            }
        }
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcSimilarPowerValidator.js.map